import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import PersonaliseExperience from "../../components/PersonaliseExperience";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { saveProfileData } from "../../redux/UserDataSlice";
import { toast } from "react-toastify";

const AvatarName = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const [inputValue, setInputValue] = useState("");
    const [error, setError] = useState("");
    const [gender, setGender] = useState("");
    const [genderError, setGenderError] = useState("");

    const { userId, accessToken } = useSelector((state) => state.loginInfo);
    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);

        if (value.trim().length < 5) {
            setError("Avatar name must be at least 5 characters.");
        } else {
            setError("");
        }
    };

    const handleGenderChange = (e) => {
        setGender(e.target.value);
        setGenderError("");
    };

    const onNavigateButton = async () => {
        if (inputValue.trim().length < 5) {
            setError("Avatar name must be at least 5 characters.");
            return;
        }

        if (!gender) {
            setGenderError("Please select a gender.");
            return;
        }
        const data = {
            gender: gender?.toUpperCase(),
            avatarName: inputValue,

        };
        try {
            const result = await apiHandler({
                url: endpoint.EDIT_PROFILE,
                method: 'POST',
                data,
                authToken: accessToken?.accessToken,
            });
            if (result.data && !result?.data?.error_description) {
                navigate("/location", { state: { inputValue, gender } });
            } else {
                toast.error(result?.data?.user_description);
            }
        } catch (error) {
            console.error(error);
            // toast.error("Something went wrong. Try again.");
        }

    };

    useEffect(() => {
        if (location.state?.avatarName) {
            setInputValue(location.state.avatarName);
        }
    }, [location.state]);

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                const result = await apiHandler({
                    url: `${endpoint.FETCH_MY_SLEF_PROFILE_PLAYER}`,
                    method: "GET",
                    authToken: accessToken?.accessToken,
                });

                if (result?.data?.baseProfile?.avatarName) {
                    if (!location.state?.avatarName) {
                        setInputValue(result.data.baseProfile.avatarName);
                    }
                }

                dispatch(saveProfileData(result?.data));
            } catch (error) {
                console.error("Error fetching profile data:", error);
            }
        };

        if (userId && accessToken?.accessToken) {
            fetchProfileData();
        }
    }, [userId, accessToken, dispatch]);

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
            <PersonaliseExperience
                navigationRoute="/home"
                title="Personalise your experience"
                subtitle="Choose your sport and level."
                style={{ width: "33%" }}
                data={
                    <>
                        <div>
                            <CustomInput
                                label="Avatar name"
                                placeholder="Your avatar must be at least 5 characters"
                                type="text"
                                value={inputValue}
                                onChange={handleInputChange}
                                error={error}
                            />
                            {error && (
                                <p style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
                                    {error}
                                </p>
                            )}
                        </div>

                        <div className="mt-4">
                            <label className="form-label fw-bold">Select Gender:</label>
                            <div className="d-flex gap-3 mt-2">
                                <label className="d-flex align-items-center">
                                    <input className="avatar-name-radio-btn me-2" type="radio" name="gender" value="male" checked={gender === "male"} onChange={handleGenderChange}
                                    />{" "}
                                    Male
                                </label>
                                <label className="d-flex align-items-center">
                                    <input
                                        className="avatar-name-radio-btn me-2"
                                        type="radio"
                                        name="gender"
                                        value="female"
                                        checked={gender === "female"}
                                        onChange={handleGenderChange}
                                    />{" "}
                                    Female
                                </label>
                                <label className="d-flex align-items-center" >
                                    <input
                                        className="avatar-name-radio-btn me-2"
                                        type="radio"
                                        name="gender"
                                        value="other"
                                        checked={gender === "other"}
                                        onChange={handleGenderChange}
                                    />{" "}
                                    Other
                                </label>
                            </div>
                            {genderError && (
                                <p style={{ color: 'red', fontSize: '14px', marginTop: '5px' }}>
                                    {genderError}
                                </p>
                            )}
                        </div>

                        <div className="pt-4">
                            <CustomButton
                                buttonText="Next"
                                className="border"
                                style={{
                                    width: '100%',
                                    height: '48px',
                                    borderRadius: '12px',
                                    background: '#006FFD',
                                    color: '#FFFFFF',
                                }}
                                onClick={onNavigateButton}
                                disabled={error}
                            />
                        </div>
                    </>
                }
            />
        </div>
    );
};

export default AvatarName;
